// production | test | develop | local
export const appEnvironment = "production"